import Video from 'components/video'
import PropTypes from 'prop-types'
import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'

const ImageCarouselVideo = ({ videoRef, onVideoParentClick, poster, src }) => (
  <div className="carousel-img__container">
    <Video
      ref={videoRef}
      loop
      onParentClick={onVideoParentClick}
      playsInline
      poster={poster}
      posterBigDesktop="45vw"
      posterDesktop="45vw"
      posterLaptop="45vw"
      posterTablet="70vw"
      ratio={0.75}
      scrollPlay={false}
      src={src}
    />
  </div>
)

ImageCarouselVideo.defaultProps = {
  videoRef: null,
}

ImageCarouselVideo.propTypes = {
  videoRef: PropTypes.func,
  onVideoParentClick: PropTypes.func.isRequired,
  poster: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
}

export default withI18next()(ImageCarouselVideo)
